import { buildModelManager } from "../builder.js";
const DefaultShopifyDraftOrderSelection = {
  __typename: true,
  id: true,
  acceptAutomaticDiscounts: true,
  allowDiscountCodesInCheckout: true,
  appliedDiscount: true,
  billingAddress: true,
  billingAddressMatchesShippingAddress: true,
  completedAt: true,
  createdAt: true,
  currency: true,
  customerId: true,
  defaultCursor: true,
  discountCodes: true,
  email: true,
  hasTimelineComment: true,
  invoiceEmailTemplateSubject: true,
  invoiceSentAt: true,
  invoiceUrl: true,
  legacyResourceId: true,
  lineItemsSubtotalPrice: true,
  marketName: true,
  marketRegionCountryCode: true,
  name: true,
  note: true,
  noteAttributes: true,
  orderId: true,
  phone: true,
  poNumber: true,
  presentmentCurrencyCode: true,
  ready: true,
  reserveInventoryUntil: true,
  shippingAddress: true,
  shippingLine: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  status: true,
  subtotalPrice: true,
  subtotalPriceSet: true,
  tags: true,
  taxExempt: true,
  taxExemptions: true,
  taxLines: true,
  taxesIncluded: true,
  totalDiscountsSet: true,
  totalLineItemsPriceSet: true,
  totalPrice: true,
  totalPriceSet: true,
  totalQuantityOfLineItems: true,
  totalShippingPriceSet: true,
  totalTax: true,
  totalTaxSet: true,
  totalWeight: true,
  transformerFingerprint: true,
  updatedAt: true,
  visibleToCustomer: true,
  warnings: true
};
const modelApiIdentifier = "shopifyDraftOrder";
const pluralModelApiIdentifier = "shopifyDraftOrders";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDraftOrderSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyDraftOrderGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyDraftOrder does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyDraftOrderManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyDraftOrderSelection,
  operations
);
export {
  DefaultShopifyDraftOrderSelection,
  ShopifyDraftOrderManager
};
//# sourceMappingURL=ShopifyDraftOrder.js.map
